import React from "react";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";

type Option = {
  value: string;
  label: string;
};

type Props = {
  label: string;
  options: Option[];
  value: any;
  onChange: (event: SelectChangeEvent<any>) => void;
  disabled?: boolean;
};

const CustomSelect = ({ label, options, value, onChange, disabled }: Props) => {
  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        sx={{
          width: "100%",
          "& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root": {
            borderRadius: "4px",
          },
          "& .MuiOutlinedInput-input": {
            backgroundColor: "#F6F6FB",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
